import { getUserProfile } from '@/shared/api/user';
import { WalletType } from '@/shared/api/user/types';

import { Method } from '../types';
import { type Responder } from './respond-with-message';

export const getUserProfileHandler = async (
  startAppArgs: any,
  sessionId: string,
  token: string,
  locale: string,
  respond: Responder
) => {
  const userProfile = await getUserProfile();

  const result = {
    avatar: userProfile.avatar,
    username: userProfile.username,
    firstName: userProfile.firstName,
    lastName: userProfile.lastName,
    telegramId: userProfile?.telegramId,
    currentGameStarted: userProfile.currentGameStarted,
    tests: {
      labels: userProfile.tests?.labels ?? [],
      miniGame: userProfile.tests?.miniGame ?? false,
    },
    wallets: userProfile.wallets.filter(
      (wallet: any) => wallet.type === WalletType.PLAYCOIN
    ),
    token,
    sessionId,
    locale,
    params: startAppArgs?.game?.raw ?? {},
  };

  respond({
    method: Method.GET_USER_PROFILE,
    value: result,
  });
};
